import React from "react";
import { MdChevronRight } from "react-icons/md";
import styles from "./product-available.module.scss";
interface ProductAvailableProps {
    onClickUrl: string;
    qtd: string;
}

export const ProductAvailable: React.FC<ProductAvailableProps> = ({  onClickUrl, qtd }) => {
    return (
        <div onClick={() => (window.location.href = onClickUrl)} aria-hidden="true" className={styles.products}>
            <div className={styles.products__line}>
                <span className={styles.products__txt}>
                    {qtd} produtos disponíveis
                </span>
                <MdChevronRight className={styles.products__arrow} />
            </div>
        </div>
    );
};
